<template>
    <div>
        <div v-if="student.partner_code != 'SBS' && student.partner_campus_location">
            <template v-if="student.partner_code == 'HKMA'">
                <p>{{$t('transcript.hkmaInstitute')}}</p>
            </template>

            <template v-else-if="student.partner_code == 'ATMS'">
                <!-- Condition 2: Malta override -->
                <template v-if="isAtmsMalta">
                    <p>{{$t('transcript.campusAttended')}} {{student.campus_attended}}</p>
                </template>

                <!-- Condition 1 & 3: Graduation date >= 2026-04-01 OR (Non-alumni AND ProgramStart >= 2026-04-01) -->
                <template v-else-if="isAtmsPostApril2026">
                    <p>{{$t('transcript.institutionAdministeringStudies')}}</p>
                    <p>{{$t('transcript.enrollmentLocation')}} {{student.campus_attended}}</p>
                </template>

                <!-- Legacy TR-P3-203 behavior (graduation date < 2026-04-01) -->
                <template v-else>
                    <p>{{$t('transcript.campusEnrolled')}} {{student.campus_attended}}</p>
                </template>
            </template>

            <template v-else>
                <p>{{$t('transcript.campusAttended')}} {{student.campus_attended}}</p>
                <p v-if="student.partner_code == 'BA' && program.program_code == 'BBA'">{{$t('transcript.studyMode')}}</p>
            </template>
        </div>

        <div class="d-flex justify-content-between">
            <div>
                <p class="mb-0">
                    <strong v-if="dba_ma_date">{{$t('transcript.degreeDate')}} {{ dba_ma_date }}</strong>

                    <strong v-else-if="program.graduate == 0">{{$t('transcript.notObtainedText')}}</strong>

                    <strong v-else>{{$t('transcript.degreeDate')}}
                        {{program.graduation_date}}</strong>
                </p>

                <p>
                    {{$t('transcript.documentIssuedText')}}
                    {{student.partner_campus_location}}, {{student.country}}
                </p>

                <p v-if="program.program_code != 'DBA' && program.program_type != 'CAP Program'">
                    <strong>{{$t('transcript.introduced')}}</strong>
                </p>
            </div>
            <div class="text-center">
                <p class="mb-5"><strong>{{$t('transcript.registrar')}}</strong></p>
                <p><strong>{{registrar}}</strong></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['student', 'program', 'registrar', 'introduced', 'dba_ma_date'],

        computed: {
            /**
             * Condition 2 — ATMS Malta override.
             */
            isAtmsMalta() {
                if (this.student.partner_code !== 'ATMS') return false;
                const title = (this.program.p_title || '').toLowerCase();
                return title.includes('malta');
            },

            /**
             * Condition 1 — ATMS with graduation date >= April 1, 2026.
             */
            isAtmsPostApril2026() {
                if (this.student.partner_code !== 'ATMS') return false;
                if (this.isAtmsMalta) return false; // Condition 2 takes precedence

                // April 1, 2026 (Month is 0-indexed in JS: 0=Jan, 3=April)
                const cutoff = new Date(2026, 3, 1);
                
                // Scenario A: Student with graduation date >= April 1, 2026
                if (this.program.graduation_date) {
                    const gradDate = this.parseCustomDate(this.program.graduation_date);
                    if (gradDate && gradDate >= cutoff) {
                        return true;
                    }
                }
                
                // Scenario B: Non-alumni student (no graduation date AND RecordType != 'alumni') 
                // with program start date >= April 1, 2026
                const recordType = (this.student.record_type || '').toLowerCase();
                const isNotAlumni = !this.program.graduation_date && recordType !== 'alumni';
                
                if (isNotAlumni && this.student.program_start) {
                    const startDate = this.parseCustomDate(this.student.program_start);
                    if (startDate && startDate >= cutoff) {
                        return true;
                    }
                }

                return false;
            }
        },

        methods: {
            /**
             * Parses dates in the format "D MMMM YYYY" or "DD MMMM YYYY" 
             * (e.g., "7 July 2026", "15 April 2026").
             * Includes fallback for abbreviated months (e.g., "Jul", "Apr").
             */
            parseCustomDate(dateStr) {
                if (!dateStr) return null;
                if (dateStr instanceof Date) return dateStr; // Fallback if API ever returns a Date object

                // Handle standard ISO format (e.g., "2020-10-09")
                if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
                    return new Date(dateStr);
                }
                
                // Handle custom format (e.g., "7 July 2026")
                const months = {
                    january: 0, jan: 0, february: 1, feb: 1, march: 2, mar: 2, 
                    april: 3, apr: 3, may: 4, june: 5, jun: 5, july: 6, jul: 6, 
                    august: 7, aug: 7, september: 8, sep: 8, sept: 8, 
                    october: 9, oct: 9, november: 10, nov: 10, december: 11, dec: 11
                };
                
                const parts = String(dateStr).trim().split(/\s+/);
                if (parts.length !== 3) return null;
                
                const day = parseInt(parts[0], 10);
                const month = months[parts[1].toLowerCase()];
                const year = parseInt(parts[2], 10);
                
                if (isNaN(day) || month === undefined || isNaN(year)) return null;
                
                return new Date(year, month, day);
            }
        }
    }

</script>
